import React from "react";

function CopyLinkIcon() {
  return (
    <span className="anticon anticon-copylink">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
      >
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M19.778 12.707a5 5 0 01-7.07 7.071l-2.83-2.828 1.415-1.414 2.828 2.828a3 3 0 104.243-4.243l-2.828-2.828 1.414-1.414 2.828 2.828zM14.121 7.05l-1.414 1.414L9.88 5.636a3 3 0 10-4.243 4.243l2.828 2.828-1.414 1.414-2.828-2.828a5 5 0 017.07-7.071l2.83 2.828zm2.122 7.778l-1.415 1.415-7.07-7.071 1.414-1.415 7.07 7.071z"
        ></path>
      </svg>
    </span>
  );
}

export default CopyLinkIcon;
